// @flow

import { User } from '../../../../types'
import {
  MyLabel,
  SourcingRoute,
} from '../reducers/sourcingAnnotationCandidates'
import { Action } from './type'

export type ResultAction = Action & {
  type:
    | 'REQUEST_SEARCH'
    | 'SUCCESS_SEARCH'
    | 'FAILURE_SEARCH'
    | 'REQUEST_DOWNLOAD'
    | 'SUCCESS_DOWNLOAD'
    | 'FAILURE_DOWNLOAD'
    | 'SUCCESS_CHANGE_STATUS'
    | 'FAILURE_CHANGE_STATUS'
    | 'SUCCESS_CHANGE_CONTACT_PERSON'
    | 'FAILED_CHANGE_CONTACT_PERSON'
    | 'SUCCESS_DELETE_COMPANY_STATUS'
    | 'FAILED_DELETE_COMPANY_STATUS'
    | 'SUCCESS_DELETE_COMPANY_CONTACT_PERSON'
    | 'FAILED_DELETE_COMPANY_CONTACT_PERSON'
    | 'SUCCESS_UPDATE_COMPANY_MEMO'
    | 'SUCCESS_UPDATE_COMPANY_FIRST_INTERVIEW_DATE'
    | 'DELETE_COMPANY_FIRST_INTERVIEW_DATE'
    | 'SUCCESS_DELETE_COMPANY_FIRST_INTERVIEW_DATE'
    | 'SUCCESS_UPDATE_COMPANY_SOURCING_ROUTE'
    | 'DELETE_SOURCING_ROUTE'
    | 'SUCCESS_DETOUCH_COMPANY_SOURCING_ROUTE'
    | 'SUCCESS_UPDATE_SOURCING_ROUTE'
    | 'SUCCESS_DELETE_SOURCING_ROUTE'
    | 'SUCCESS_UPDATE_COMPANY_MY_LABELS'
}

type BaseCompany = {
  name: string
  companyId: string
  established?: string
  origin: string[]
  shareholderStatus: string[]
  totalFunding: number
  latestInitialSeries?: string
  valuation?: number
  lastValuationDate?: string
  vbStage?: string
  industry?: string
  institute: string[]
  state?: string
  employees?: number | { start: number; end: number | null } | null
  representativeName?: string
  country?: string
  address?: string
  corporateNumber?: string
  telephone?: string | null
  created?: string
  updated?: string
  description?: string
  lastFundraised?: string
  researchStatus?: string
  website?: string
  tags: Tag[]
  investingStatus?: string
  contactPerson?: { firstName: string; lastName: string }
  investingStatusUpdated?: string
  memo?: { content: string }
  firstInterviewDate?: string
  sourcingRoute?: SourcingRoute
  myLabels: MyLabel[]
  cbLatestRoundType?: string
}

export type Tag = {
  name: string
  path: string
}

type PrivateCompany = BaseCompany & {
  type: '未公開企業'
  ipoCategory?: null
  market?: null
  ipoed?: null
  ipoJikasougaku?: null
  ipoJikasougakuPublicPrice?: null
}

type IPOCompany = BaseCompany & {
  type: 'IPO企業'
  ipoCategory?: string
  market: string
  ipoed: string
  ipoJikasougaku: number
  ipoJikasougakuPublicPrice?: number
}

export type Company = PrivateCompany | IPOCompany

type SearchResult = {
  count: number
  limit: number
  offset: number
  data: Company[]
}

export const REQUEST_SEARCH = 'REQUEST_SEARCH'
export function requestSearch() {
  return { type: REQUEST_SEARCH }
}

export const SUCCESS_SEARCH = 'SUCCESS_SEARCH'
export function successSearch(data: SearchResult) {
  return { type: SUCCESS_SEARCH, payload: data }
}

export const FAILURE_SEARCH = 'FAILURE_SEARCH'
export function failureSearch(e: any) {
  console.log('Error: FAILURE_SEARCH', e)
  return { type: FAILURE_SEARCH }
}

export const REQUEST_DOWNLOAD = 'REQUEST_DOWNLOAD'
export function requestDownload() {
  return { type: REQUEST_DOWNLOAD }
}

export const SUCCESS_DOWNLOAD = 'SUCCESS_DOWNLOAD'
export function successDownload() {
  return { type: SUCCESS_DOWNLOAD }
}

export const FAILURE_DOWNLOAD = 'FAILURE_DOWNLOAD'
export function failureDownload(e: any) {
  console.log('Error: FAILURE_DOWNLOAD', e)
  return { type: FAILURE_DOWNLOAD }
}

export const FETCH_COMPANIES = 'FETCH_COMPANY'
export function fetchCompanies() {
  return { type: FETCH_COMPANIES }
}

export const CHANGE_STATUS = 'CHANGE_STATUS'
export function changeStatus(payload: {
  id: string
  companyId: string
  name: string
  user: User
}) {
  return { type: CHANGE_STATUS, payload }
}

export const DELETE_COMPANY_STATUS = 'DELETE_COMPANY_STATUS'
export function deleteCompanyStatus(payload: {
  companyId: string
  user: User
}) {
  return { type: DELETE_COMPANY_STATUS, payload }
}

export const CHANGE_CONTACT_PERSON = 'CHANGE_CONTACT_PERSON'
export function changeContactPerson(payload: {
  id: number
  companyId: string
  firstName: string
  lastName: string
  user: User
}) {
  return { type: CHANGE_CONTACT_PERSON, payload }
}

export const DELETE_COMPANY_CONTACT_PERSON = 'DELETE_COMPANY_CONTACT_PERSON'
export function deleteCompanyContactPerson(payload: {
  companyId: string
  user: User
}) {
  return { type: DELETE_COMPANY_CONTACT_PERSON, payload }
}

export const UPDATE_COMPANY_MEMO = 'UPDATE_COMPANY_MEMO'
export function updateCompanyMemo(payload: {
  companyId: string
  memo: string
}) {
  return { type: UPDATE_COMPANY_MEMO, payload }
}

export const UPDATE_COMPANY_FIRST_INTERVIEW_DATE =
  'UPDATE_COMPANY_FIRST_INTERVIEW_DATE'
export function updateCompanyFirstInterviewDate(payload: {
  companyId: string
  firstInterviewDate: string
  user: User
}) {
  return { type: UPDATE_COMPANY_FIRST_INTERVIEW_DATE, payload }
}

export const DELETE_COMPANY_FIRST_INTERVIEW_DATE =
  'DELETE_COMPANY_FIRST_INTERVIEW_DATE'
export function deleteCompanyFirstInterviewDate(payload: {
  companyId: string
  user: User
}) {
  return { type: DELETE_COMPANY_FIRST_INTERVIEW_DATE, payload }
}

export const SUCCESS_CHANGE_STATUS = 'SUCCESS_CHANGE_STATUS'
export function successChangeStatus(payload: {
  companyId: string
  name: string
}) {
  return { type: SUCCESS_CHANGE_STATUS, payload }
}

export const FAILED_CHANGE_STATUS = 'FAILED_CHANGE_STATUS'
export function faildChangeStatus(message: string) {
  console.log('Error:  FAILED_CHANGE_STATUS', message)
  return { type: FAILED_CHANGE_STATUS }
}

export const SUCCESS_CHANGE_CONTACT_PERSON = 'SUCCESS_CHANGE_CONTACT_PERSON'
export function successChangeContactPerson(payload: {
  id: number
  companyId: string
}) {
  return { type: SUCCESS_CHANGE_CONTACT_PERSON, payload }
}

export const FAILED_CHANGE_CONTACT_PERSON = 'FAILED_CHANGE_CONTACT_PERSON'
export function faildChangeContactPerson(message: string) {
  console.log('Error:  FAILED_CHANGE_STATUS', message)
  return { type: FAILED_CHANGE_CONTACT_PERSON }
}

export const SUCCESS_DELETE_COMPANY_STATUS = 'SUCCESS_DELETE_COMPANY_STATUS'
export function successDeleteCompanyStatus(payload: { companyId: string }) {
  return { type: SUCCESS_DELETE_COMPANY_STATUS, payload }
}

export const FAILED_DELETE_COMPANY_STATUS = 'FAILED_DELETE_COMPANY_STATUS'
export function faildDeleteCompanyStatus(message: string) {
  console.log('Error:  FAILED_DELETE_COMPANY_STATUS', message)
  return { type: FAILED_DELETE_COMPANY_STATUS }
}

export const SUCCESS_DELETE_COMPANY_CONTACT_PERSON =
  'SUCCESS_DELETE_COMPANY_CONTACT_PERSON'
export function successDeleteCompanyContactPerson(payload: {
  companyId: string
}) {
  return { type: SUCCESS_DELETE_COMPANY_CONTACT_PERSON, payload }
}

export const FAILED_DELETE_COMPANY_CONTACT_PERSON =
  'FAILED_DELETE_COMPANY_CONTACT_PERSON'
export function faildDeleteCompanyContactPerson(message: string) {
  console.log('Error:  FAILED_DELETE_COMPANY_CONTACT_PERSON', message)
  return { type: FAILED_DELETE_COMPANY_CONTACT_PERSON }
}

export const SUCCESS_UPDATE_COMPANY_MEMO = 'SUCCESS_UPDATE_COMPANY_MEMO'
export function successUpdateCompanyMemo(payload: {
  companyId: string
  memo: string
}) {
  return { type: SUCCESS_UPDATE_COMPANY_MEMO, payload }
}

export const SUCCESS_UPDATE_COMPANY_FIRST_INTERVIEW_DATE =
  'SUCCESS_UPDATE_COMPANY_FIRST_INTERVIEW_DATE'
export function successUpdateCompanyFirstInterviewDate(payload: {
  companyId: string
  firstInterviewDate: string
}) {
  return { type: SUCCESS_UPDATE_COMPANY_FIRST_INTERVIEW_DATE, payload }
}

export const SUCCESS_DELETE_COMPANY_FIRST_INTERVIEW_DATE =
  'SUCCESS_DELETE_COMPANY_FIRST_INTERVIEW_DATE'
export function successDeleteCompanyFirstInterviewDate(payload: {
  companyId: string
}) {
  return { type: SUCCESS_DELETE_COMPANY_FIRST_INTERVIEW_DATE, payload }
}

export const SUCCESS_UPDATE_COMPANY_MY_LABELS =
  'SUCCESS_UPDATE_COMPANY_MY_LABELS'
export function successUpdateCompanyMyLabels(payload: {
  companyId: string
  companyMyLabels: MyLabel[]
}) {
  return { type: SUCCESS_UPDATE_COMPANY_MY_LABELS, payload }
}
